import React from 'react'
import { Routes, Route } from 'react-router'
import { LoginPage } from './pages/LoginPage'
import { ForgotPasswordPage } from './pages/ForgotPasswordPage'
import { ResetPasswordPage } from './pages/ResetPasswordPage'
import { EmailVerificationPendingPage } from './pages/EmailVerificationPendingPage'
import { PendingApprovalPage } from './pages/PendingApprovalPage' // P-017: New page for pending org approval
import { RegisterPage } from './pages/RegisterPage'
import { CallbackPage } from './pages/CallbackPage'
import { AuthorizePage } from './pages/AuthorizePage'
import { InvitePage } from './pages/InvitePage'
import OrganizationSignupPage from './pages/OrganizationSignupPage'
import { VerificationFailedPage } from './pages/VerificationFailedPage'
import { CreateOrganizationPage } from './pages/CreateOrganizationPage'
import { LogoutPage } from './pages/LogoutPage'
import { DevicePage } from './pages/DevicePage'
import { WaitlistPage } from './pages/WaitlistPage'
import { WaitlistCompletePage } from './pages/WaitlistCompletePage'
import { WaitlistPendingPage } from './pages/WaitlistPendingPage'

const App: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<LoginPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/callback" element={<CallbackPage />} />
      <Route path="/logout" element={<LogoutPage />} />
      <Route path="/authorize" element={<AuthorizePage />} />
      <Route path="/invite" element={<InvitePage />} />
      <Route path="/organization-signup" element={<OrganizationSignupPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/verify-email-pending" element={<EmailVerificationPendingPage />} />
      <Route path="/pending-approval" element={<PendingApprovalPage />} /> {/* P-017: New route */}
      <Route path="/onboarding/verification-failed" element={<VerificationFailedPage />} />
      <Route path="/onboarding/create-organization" element={<CreateOrganizationPage />} />
      <Route path="/device" element={<DevicePage />} /> {/* RFC 8628: Device Code verification */}
      <Route path="/waitlist" element={<WaitlistPage />} />
      <Route path="/waitlist/complete" element={<WaitlistCompletePage />} />
      <Route path="/waitlist/pending" element={<WaitlistPendingPage />} />
    </Routes>
  )
}

export default App
